export enum IntegrationSettingOrderParserType {
    AI = 1,
    FullCircleTMS = 2,
    Sylectus = 3,
}

export enum SubjectRuleType {
    Contains = 2,
    StartsWith = 3,
    EndsWith = 4,
}

export enum EmailFilterType {
    Domain = 1,
    Email = 2
}
